<template>
  <a
    v-bind="$attrs"
    :href="resolvedHref"
    :target="target"
    :rel="computedRel"
    @click="handleClick"
  >
    <slot />
  </a>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    to: {
      type: [String, Object],
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    replace: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: ""
    },
    rel: {
      type: String,
      default: ""
    },
    guard: {
      type: Function,
      default: null
    }
  },
  computed: {
    resolvedHref() {
      if (this.href) {
        return this.href;
      }
      if (!this.to) {
        return "";
      }
      return this.$router.resolve(this.to).href;
    },
    isExternalLink() {
      return !!this.href && !this.to;
    },
    computedRel() {
      if (this.rel) {
        return this.rel;
      }
      return this.target === "_blank" ? "noopener noreferrer" : "";
    }
  },
  methods: {
    isModifiedEvent(event) {
      return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    },
    async handleClick(event) {
      if (this.disabled) {
        event.preventDefault();
        return;
      }

      if (this.guard) {
        const guardResult = await this.guard(event);
        if (guardResult === false) {
          event.preventDefault();
          return;
        }
      }

      if (this.isExternalLink) {
        return;
      }

      if (
        !this.to ||
        event.defaultPrevented ||
        this.isModifiedEvent(event) ||
        event.button !== 0 ||
        this.target === "_blank"
      ) {
        return;
      }

      event.preventDefault();
      const method = this.replace ? "replace" : "push";
      this.$router[method](this.to);
    }
  }
};
</script>

<style scoped>
a {
  color: inherit;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SeoLink.vue